module.exports = __webpack_public_path__ + "img/火龍果-2.f464d067.jpg";